module.exports = __webpack_public_path__ + "img/envelope.95e02b27.svg";